import React from 'react';
import { Image } from '@yme/atoms/image';
import { INDENT } from '@yme/tokens/sizes';
import { getJustifyContent } from './helpers';
import { EventPanelStyled } from './styled';
export function EventPanel({ eventLogo, flag, logoMaxHeight = INDENT.m, }) {
    return (React.createElement(EventPanelStyled, { justifyContent: getJustifyContent(eventLogo?.src, flag?.src), alignItems: "center", isFullWidth: true },
        eventLogo?.src && (React.createElement(Image, { src: eventLogo.src, maxHeight: logoMaxHeight, width: "auto" })),
        flag?.src && (React.createElement(Image, { src: flag.src, maxHeight: logoMaxHeight, width: "auto" }))));
}
EventPanel.displayName = 'EventPanel_Molecule';
